import { render, staticRenderFns } from "./AllBankrupt.vue?vue&type=template&id=446d2572&scoped=true&"
import script from "./AllBankrupt.vue?vue&type=script&lang=js&"
export * from "./AllBankrupt.vue?vue&type=script&lang=js&"
import style0 from "./AllBankrupt.vue?vue&type=style&index=0&id=446d2572&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446d2572",
  null
  
)

export default component.exports